import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import vuex from './store/index'
import permission from './directive/permission'
import iupigin from './styles/index.scss'
import JsonViewer from "vue3-json-viewer"
import 'vue3-json-viewer/dist/index.css';

import { createFromIconfontCN } from '@ant-design/icons-vue';

const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2033419_extitw862n.js', // 在 iconfont.cn 上生成
});



const app = createApp(App);
app.use(router);
app.use(Antd);
app.use(vuex);
app.component('my-icon', MyIcon)
app.config.silent = true
//自定义全局组件部分
app.use(permission)
app.use(JsonViewer)
// 分环境处理
if (process.env.NODE_ENV === 'development') {
    // if ('__VUE_DEVTOOLS_GLOBAL_HOOK__' in window) {
    //     // 这里__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue赋值一个createApp实例
    //     window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app
    // }
    app.config.devtools = true
}


const requireComponent = require.context('@/components', true, /\.vue$/);

(component => {
    // 遍历获取组件对象，注册组件
    component.keys().map(fileName => {
        const com = requireComponent(fileName)['default'];
        if (com.hasOwnProperty("componentname")) {
            const componentname = "df-" + com.componentname;
            app.component(componentname, com);
        }
    });
})(requireComponent);




app.mount('#app');
